exports.onClientEntry = () => {
  if (typeof window === "undefined") return;

  const pathname = window.location.pathname;
  const lower = pathname.toLowerCase();

  if (pathname !== lower) {
    const newUrl =
      lower +
      window.location.search +
      window.location.hash;

    // Replace instead of navigate to avoid back-button loop
    window.location.replace(newUrl);
  }
};